import 'consumerweb-shim';
import 'vxpattern-lib-paypal/dist/vx-lib.js'
import React from 'react'
import { Route, Switch, Router } from 'react-router-dom'
import history from '../routes/configureHistory';
import ReactDOM from 'react-dom'
import ButtonFactoryWizard from '../buttons/components/ButtonFactoryWizard';
import ButtonDetails from '../buttons/components/buttonDetails/ButtonDetails';
import { Provider } from 'react-redux';
import getStore from '../buttons/store/configureStore';
import '../utility/csrf';
import { handleAjaxError } from '../buttons/utils/globalHandler';
import MarketingHeader from './marketingHeader/MarketingHeader';

handleAjaxError();
const store = getStore();

const App = () => {
	return (
		<div>
			<Router history={history}>
				<Switch>
					<Route exact path="/donate/buttons/create" component={ButtonFactoryWizard} />
					<Route exact path="/donate/buttons/login" component={ButtonFactoryWizard} />
					<Route exact path="/donate/buttons/:buttonId/edit" component={ButtonFactoryWizard} />
					<Route exact path="/donate/buttons/:buttonId/duplicate" component={ButtonFactoryWizard} />
					<Route exact path="/donate/buttons/:buttonId" component={ButtonDetails} />
					<Route exact path="/donate/buttons" component={ButtonFactoryWizard} />
				</Switch>
			</Router>
		</div>
	)
}

ReactDOM.render(
	<Provider store={store}>
		<Router history={history}>
			<App />
		</Router>
	</Provider>,
	document.getElementById('react-buttons-container')
)

if (document.getElementById('marketing-header-container')) {
	ReactDOM.render(
		<Provider store={store}>
			<Router history={history}>
				<div>
					<Route path="/" component={MarketingHeader} />
				</div>
			</Router>
		</Provider>,
		document.getElementById('marketing-header-container')
	)
}



// WEBPACK FOOTER //
// ./pages/buttonFactory.js